import { render, staticRenderFns } from "./Landing-Bets.vue?vue&type=template&id=6d9b6275&scoped=true&"
import script from "./Landing-Bets.vue?vue&type=script&lang=js&"
export * from "./Landing-Bets.vue?vue&type=script&lang=js&"
import style0 from "./Landing-Bets.vue?vue&type=style&index=0&id=6d9b6275&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b6275",
  null
  
)

export default component.exports